import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 12px;

  transition: min-height 150ms ease-in-out;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const LabelTitle = styled.label`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const MainContainer = styled.div`
  overflow: hidden;

  min-height: 52px;
  max-height: 100%;

  display: flex;
  flex-direction: row;
  gap: 16px;

  border: 1px solid var(--border-neutral, #bbc1d3);
  background: var(--background-elevation-base, #fff);
  border-radius: 4px;

  padding: 12px 16px;
  box-sizing: border-box;
`

export const TextAreaContainer = styled.div`
  flex: 1;

  overflow-y: scroll;

  display: flex;
`

export const TextArea = styled.textarea`
  flex: 1;
  overflow: hidden;

  resize: none;
  border: none;
  outline: none;
  flex: 1;
  color: var(--foreground-neutral, #14171f);
  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  padding-top: 4px;
  box-sizing: border-box;

  font-family: ${({ theme }) => theme.fontFamily};

  ::placeholder {
    color: var(--foreground-neutral-faded, #4d5874);
    opacity: 0.5;
  }

  transition: height 150ms ease-in-out;

  :focus {
    transition: none;
  }

  :disabled {
    background-color: #fff;
  }
`

export const CameraButtonContainer = styled.label`
  cursor: pointer;

  height: 28px;
  width: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const CameraButtonInput = styled.input`
  position: absolute;

  width: 100%;
  height: 100%;

  display: none;
`

export const FilesPreviewContainter = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: flex-end; */
  gap: 8px;

  width: 100%;
`

export const FileContainter = styled.div`
  position: relative;
`

export const FilePreview = styled.img`
  cursor: pointer;

  width: 160px;
  height: 90px;

  border-radius: 4px;
  object-fit: cover;

  border: 1px solid rgba(0, 0, 0, 0.05);
`

export const DeleteFileContainer = styled.div`
  position: absolute;

  top: -10px;
  right: -12px;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  border-radius: 50%;
  background-color: white;

  svg {
    path {
      fill: black;
    }
  }
`

export const SendButtonContainer = styled.div<{ disabled?: boolean }>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  height: 28px;
  width: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  background: ${({ disabled }) =>
    disabled ? 'var(--Background-Neutral, #DFE2EA)' : 'var(--Background-Primary, #5A58F2)'};

  svg {
    width: 14px;
    height: 14px;

    path {
      fill: ${({ disabled }) => (disabled ? 'var(--Foreground-Neutral-faded, #4D5874)' : 'white')};
    }
  }
`

export const LoaderContainer = styled.div`
  flex: 1;

  color: white;
`
